<!-- @format -->

<div *ngFor="let studyGroupSet of courseUnitRealisation.studyGroupSets">
  <div role="heading" [attr.aria-level]="subGroupLevel" class="sis-label">{{ studyGroupSet.name | localizedString: language }}</div>
  <ng-container *ngFor="let studySubGroup of studyGroupSet.studySubGroups">
    <app-student-study-sub-group-structure [language]="language" [studySubGroup]="studySubGroup"> </app-student-study-sub-group-structure>
  </ng-container>
</div>
